module.exports = __webpack_public_path__ + "static/media/diamond-1-company.3987b4d3.png";